import React from "react";
import { brl, pct } from "../utils/formatters";

/**
 * Painel "Crédito aproveitado" — barras empilhadas por tributo mostrando a
 * parte do débito coberta por crédito (equivalente ao creditPanel do HTML).
 */
export default function CreditPanel({ rows, sub }) {
  return (
    <div className="panel-card">
      <div className="panel-head">
        <div>
          <h5>Crédito aproveitado</h5>
          <p className="panel-sub">{sub}</p>
        </div>
      </div>
      <div className="legend">
        <span><i className="sw-credit" />Crédito aproveitado</span>
        <span><i className="sw-pay" />A recolher</span>
      </div>
      <div className="credit-rows">
        {rows.map((r) => {
          const share = r.deb > 0 ? r.cred / r.deb : r.cred > 0 ? 1 : 0;
          const over = r.cred > r.deb + 0.005;
          const fill = Math.max(0, Math.min(share, 1));
          return (
            <div className="credit-row" key={r.k}>
              <span className="name">{r.k}</span>
              <div
                className="bar2 stack"
                title={`${r.k}\nDébito ${brl(r.deb)}\nCrédito ${brl(r.cred)}\n${over ? "Saldo credor " + brl(r.cred - r.deb) : "A recolher " + brl(r.deb - r.cred)}`}
              >
                {fill > 0 && (
                  <div
                    className="seg sw-credit"
                    style={{ width: `calc(${(fill * 100).toFixed(2)}% - ${fill < 1 ? 1 : 0}px)` }}
                  />
                )}
                {fill < 1 && <div className="seg sw-pay" style={{ flex: 1 }} />}
              </div>
              <span className="val">
                {over ? (
                  <>
                    <b>Saldo credor</b>
                    <span>{brl(r.cred - r.deb)}</span>
                  </>
                ) : (
                  <>
                    <b>{pct(share)}</b>
                    <span>cobertos</span>
                  </>
                )}
              </span>
              <span className="detail">Débito {brl(r.deb)} · Crédito {brl(r.cred)}</span>
            </div>
          );
        })}
      </div>
      <p className="footnote">ICMS-ST e ISS não geram crédito nesta apuração.</p>
    </div>
  );
}
